// eslint-disable-next-line no-restricted-imports
import { Menu as MenuBase } from '@mui/material';
import { NavigationLink } from 'components/NavigationLink';

import { Icon } from '../Icon';
import { Stack } from '../Stack';
import { Typography } from '../Typography';
import { Colors, cx } from '../theme';

import { MenuItemStyled } from './Menu.styles';
import { MenuProps } from './types';

/**
 * Menu component.
 */
export const Menu = <T extends string | number>({
  open,
  options,
  anchorEl,
  onClose,
  onClickOption,
  onMouseLeave,
  ...popoverProps
}: MenuProps<T>) => (
  <MenuBase
    {...popoverProps}
    anchorEl={anchorEl}
    open={open}
    slotProps={{
      list: { onMouseLeave },
      backdrop: {
        onClick: (e) => {
          e.stopPropagation();
        },
      },
    }}
    onClose={onClose}
  >
    {options.map((option) => (
      <MenuItemStyled
        key={option.value}
        color={option.color}
        onClick={(e) => {
          e.stopPropagation();
          if (option.isValueLink) {
            onClose();
            return;
          }
          onClickOption?.(option, e);
        }}
      >
        <Stack
          alignItems="center"
          direction="row"
          flex={1}
          justifyContent="space-between"
          spacing={12}
        >
          <Stack alignItems="center" direction="row" spacing={12}>
            {option.Icon && (
              <option.Icon
                className="menu-item-icon"
                color="inherit"
                size={20}
              />
            )}
            {option.isValueLink ? (
              <NavigationLink
                className="menu-item-link"
                to={String(option.value)}
              >
                <Typography
                  className={cx('menu-item-label', option.className)}
                  variant="caption"
                >
                  {option.label}
                </Typography>
              </NavigationLink>
            ) : (
              <Typography
                className={cx('menu-item-label', option.className)}
                color="inherit"
                variant="caption"
              >
                {option.label}
              </Typography>
            )}
          </Stack>

          {option.isActive && (
            <Icon.Check color={option.color ?? Colors.blue500} />
          )}
        </Stack>
      </MenuItemStyled>
    ))}
  </MenuBase>
);
